import axios from 'axios';
import {
  FormPageRequest,
  FormPageResponse,
  FormAuthenticationRequest,
  FormAuthenticatedData,
} from 'backend';
import { getAuthorizationHeaderProperty, getRequestHeaders } from './shared';

export type FetchInitialFormDataPayload = {
  endpoint: string;
};
export const fetchInitialFormData = async ({
  endpoint,
}: FetchInitialFormDataPayload): Promise<FormPageResponse> => {
  const res = await axios.get<FormPageResponse>(
    `${endpoint}${location.search ?? ''}`,
    {
      headers: getRequestHeaders(),
    }
  );
  return res.data;
};

export type PostInputDataPayload = {
  endpoint: string;
  payload: FormPageRequest;
  authentication?: FormAuthenticatedData;
};

export const postInputData = async ({
  endpoint,
  payload,
  authentication,
}: PostInputDataPayload): Promise<FormPageResponse> => {
  const headersPayload = authentication
    ? {
        'X-From': location.origin,
        Authorization: getAuthorizationHeaderProperty(authentication.token),
      }
    : {
        'X-From': location.origin,
      };
  const nextPage = await axios.post<FormPageResponse>(endpoint, payload, {
    headers: getRequestHeaders(headersPayload),
  });
  return nextPage.data;
};

export type PostAuthInputDataPayload = {
  endpoint: string;
  payload: FormAuthenticationRequest;
};
export const postAuthInputDate = async ({
  endpoint,
  payload,
}: PostAuthInputDataPayload): Promise<FormPageResponse> => {
  const nextPage = await axios.post<FormPageResponse>(endpoint, payload, {
    headers: getRequestHeaders({
      'X-From': location.origin,
    }),
  });
  return nextPage.data;
};
